// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__W3ibe","content":"styles_content__39HOd","selectAll":"styles_selectAll__2hhFS"};